import { Component, OnInit, EventEmitter } from '@angular/core';
import { UserManagementService } from 'app/services/user-management.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from 'app/services/data.service';
import { ProjectManagementService } from 'app/services/project-management.service';
import { FrontEndService } from 'app/services/front-end.service';
import { LogService } from 'app/services/log.service';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { StateService } from '@uirouter/angular';
import { Transition } from '@uirouter/angular';

@Component({
    selector: 'app-evaluation',
    templateUrl: './evaluation.component.html',
    styleUrls: ['./evaluation.component.scss']
})
export class EvaluationComponent implements OnInit {

    search_results_score = 0;
    claim_chart_score = 0;
    search_history_score= 0;
    data_coverage = 0;
    sum= 0;
    x_y_a = "";
    comments="";
    application_of_search_result="";
    errorMessage = '';
    currentUserProfile: any;
    fullScreenLoader = false;

    // Error Variables
    search_results_score_error = false;
    claim_chart_score_error = false;
    search_history_score_error = false;
    data_coverage_error = false;
    sum_error = false;
    x_y_a_error = false;
    comments_error = false;
    application_of_search_result_error = false;

    // On error, Focus variables
    public search_results_score_focus = new EventEmitter<boolean>();
    public claim_chart_score_focus = new EventEmitter<boolean>();
    public search_history_score_focus = new EventEmitter<boolean>();
    public data_coverage_focus = new EventEmitter<boolean>();

    constructor(
        private user_management_service: UserManagementService,
        private modalService: NgbModal,
        public data_service: DataService,
        private project_management_service: ProjectManagementService,
        private _location: Location,
        private transition: Transition,
        private translate: TranslateService,
        public front_end_service: FrontEndService,
        private logService: LogService,
        private stateService: StateService
    ) { }

    ngOnInit() {
        this.currentUserProfile = this.data_service.currentUser;
        this.getProjectEvaluation();
    }

    getProjectEvaluation() {
        this.fullScreenLoader = true;
        this.project_management_service.getEvaluation(this.transition.params().project_id, (resp) => {
                this.fullScreenLoader = false;

                if (this.currentUserProfile['role'] == 2) {
                    this.stateService.go("Forbidden");
                }

                if(resp.status === true) {
                    this.search_results_score = resp.data['search_results_score'];
                    this.claim_chart_score = resp.data['claim_chart_score'];
                    this.search_history_score = resp.data['search_history_score'];
                    this.data_coverage = resp.data['data_coverage'];
                    this.sum = resp.data['sum'];
                    this.x_y_a = resp.data['x_y_a'];
                    this.comments = resp.data['comments'];
                    this.application_of_search_result = resp.data['application_of_search_result'];
                }

                this.setMaxValue();
            }
        );
    }

    x_y_aChanged(event) {
        this.x_y_a = event.value;
    }

    onSubmit(form) {
        this.logService.printLog("form" + JSON.stringify(form));
        this.hideAllError();

        let any_error = false;

        // Remove Null
        const keys = Object.keys(form);
        for (const i in keys) {
            if (form[keys[i]] == null || form[keys[i]] === undefined) {
                delete form[keys[i]];
            }
        }

        if(parseInt(form.search_results_score) > 65 || parseInt(form.search_results_score) < 0 ) {
            this.hideAllError();
            this.search_results_score_focus.emit(true);
            this.search_results_score_error = true;
            this.errorMessage = 'search_results_score_error';
            any_error = true;
        } else if(parseInt(form.claim_chart_score) > 15 || parseInt(form.claim_chart_score) < 0 ) {
            this.hideAllError();
            this.claim_chart_score_focus.emit(true);
            this.claim_chart_score_error = true;
            this.errorMessage = 'claim_chart_score_error';
            any_error = true;
        } else if(parseInt(form.search_history_score) > 10 || parseInt(form.search_history_score) < 0 ) {
            this.hideAllError();
            this.search_history_score_focus.emit(true);
            this.search_history_score_error = true;
            this.errorMessage = 'search_history_score_error';
            any_error = true;
        } else if(parseInt(form.data_coverage) > 10 || parseInt(form.data_coverage) < 0 ) {
            this.hideAllError();
            this.search_history_score_focus.emit(true);
            this.data_coverage_error = true;
            this.errorMessage = 'data_coverage_error'
            any_error = true;
        }
        if (!any_error) {
            this.projectEvaluation(form)
        }
    }

    projectEvaluation(data) {
        this.fullScreenLoader = true;
        this.project_management_service.postEvaluation(data, this.transition.params().project_id, (resp) => {
            this.fullScreenLoader = false;
            if(resp.status === true) {
                this.front_end_service.addToast(
                    "Success",
                    "project_evaluation_saved",
                    "success"
                );

                this.front_end_service.back();
            }
        });
    }

    hideAllError() {
        this.search_results_score_error = false;
        this.claim_chart_score_error = false;
        this.search_history_score_error = false;
        this.data_coverage_error = false;
        this.sum_error = false;
        this.x_y_a_error = false;
        this.comments_error = false;
        this.application_of_search_result_error = false;
    }

    setMaxValue() {
        if(this.search_results_score === 0 || this.search_results_score === null) {
            this.search_results_score = 65;
        }
        if(this.claim_chart_score === 0 || this.claim_chart_score === null) {
            this.claim_chart_score = 15;
        }
        if(this.search_history_score === 0 || this.search_history_score === null) {
            this.search_history_score = 10;
        }
        if(this.data_coverage === 0 || this.data_coverage === null) {
            this.data_coverage = 10;
        }
    }
}
